import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
export const ArrowDownListItem = (props) => {
    const { children, className = '' } = props;
    const lastStyle = css `
    &:last-child > div {
      border: none;
      padding-bottom: 0;
    }

    &:last-child > span {
      display: none;
    }
  `;
    return (_jsxs("div", Object.assign({ className: clsx('relative', className), css: lastStyle }, { children: [_jsx("div", Object.assign({ className: clsx('pb-8', 'border-solid border-b border-t-0 border-x-0 border-gray-300') }, { children: children })), _jsx("span", { className: clsx('absolute top-[100%]', 'w-0 h-0', 'border-solid border-gray-300', 'border-b-transparent', 'border-y-[9px]', 'border-x-[6px] border-x-transparent', 'left-[6px] ml-[9px]') })] })));
};
